/* @flow */
import Styled from './styled';

export default Styled;
